"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useMediaQuery", {
  enumerable: true,
  get: function get() {
    return _reactResponsive.useMediaQuery;
  }
});
exports["default"] = exports.useIsBigScreen = exports.useIsPortrait = exports.useIpad = exports.useIsHandheld = exports.useIsTablet = exports.useIsMobile = exports.useIsDesktopUp = void 0;

var _reactResponsive = require("react-responsive");

var WIDTH_BREAKPOINTS = {
  EXTRA_EXTRA_LARGE_DESKTOP: 1920,
  EXTRA_LARGE_DESKTOP: 1440,
  LARGE_DESKTOP: 1200,
  DESKTOP: 992,
  TABLET: 768,
  MOBILE: 576
};

var useIsDesktopUp = function useIsDesktopUp() {
  return (0, _reactResponsive.useMediaQuery)({
    query: "(min-width: ".concat(WIDTH_BREAKPOINTS.DESKTOP, "px)")
  });
}; // 1. These two will be used in most cases


exports.useIsDesktopUp = useIsDesktopUp;

var useIsMobile = function useIsMobile() {
  return (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: ".concat(WIDTH_BREAKPOINTS.TABLET, "px)")
  });
}; // 2. These two will be used in most cases


exports.useIsMobile = useIsMobile;

var useIsTablet = function useIsTablet() {
  var min = (0, _reactResponsive.useMediaQuery)({
    query: "(min-width: ".concat(WIDTH_BREAKPOINTS.TABLET, "px)")
  });
  var max = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: ".concat(WIDTH_BREAKPOINTS.LARGE_DESKTOP, "px)")
  });
  return min && max;
}; // 3. These two will be used in most cases


exports.useIsTablet = useIsTablet;

var useIsHandheld = function useIsHandheld() {
  var isMobile = useIsMobile();
  var isTablet = useIsTablet();
  return isMobile || isTablet;
};

exports.useIsHandheld = useIsHandheld;

var useIpad = function useIpad() {
  return (0, _reactResponsive.useMediaQuery)(null, 'iPad');
};

exports.useIpad = useIpad;

var useIsPortrait = function useIsPortrait() {
  return (0, _reactResponsive.useMediaQuery)({
    query: '(orientation: portrait)'
  });
};

exports.useIsPortrait = useIsPortrait;

var useIsBigScreen = function useIsBigScreen() {
  return (0, _reactResponsive.useMediaQuery)({
    query: "(min-width: ".concat(WIDTH_BREAKPOINTS.EXTRA_EXTRA_LARGE_DESKTOP, "px)")
  });
};

exports.useIsBigScreen = useIsBigScreen;
var _default = WIDTH_BREAKPOINTS;
exports["default"] = _default;